import { createAction } from "@reduxjs/toolkit";

export const fingerprintLoad = createAction("fingerprint/load");
export const fingerprintSet = createAction<string>("fingerprint/set");
